// -----------------------------------------------------------------------
// <copyright file="SignInSection.tsx" company="Microsoft">
//     copyright (c) Microsoft. All rights reserved.
// </copyright>
// -----------------------------------------------------------------------

import { mergeStyles } from '@fluentui/react';
import { ITheme } from '@fluentui/theme';
import React from 'react';
import { useSelector } from 'react-redux';
import { IAppState } from '../../../web-legacy/models/reduxState';
import { SignInScenarioContainer } from '../../../web-legacy/packages/contactUs/containerComponents/SignInScenarioContainer';
import {
  getContactUsClassNames,
  getContactUsStyles,
} from '../../../web-legacy/packages/contactUs/styles/contactUsStyles';
import { sanitizeHTML } from '../../../web-legacy/utilities';
import { getString } from '../../utils/stringLoader';
interface IProps {
  theme?: ITheme;
}

export const SignInSection = (props: IProps) => {
  const errorOnSignIn = useSelector((appState: IAppState) => appState.ContactState.ModalitySectionState.errorOnSignIn);

  const contactUsClassNames = getContactUsClassNames(getContactUsStyles, { theme: props.theme });
  let Body: JSX.Element = null;

  if (!errorOnSignIn) {
    Body = <SignInScenarioContainer />;
  } else {
    let tryAgainLink = getString('result_errorOnSignInText');
    tryAgainLink = tryAgainLink
      // modify the UI string to execute the Help Tab reload
      .replace(
        '{0}',
        '<a href="#" id="reloadForSignInError" data-bi-area="modalitiesSection" data-bi-name="retryOnSignInLink" data-bi-formnm="maxFunnel" onClick="window.external.ExecuteToolbarCommand(7903)">'
      )
      .replace('{1}', '</a>');
    Body = (
      // eslint-disable-next-line react/no-danger
      <div
        id="problemWithSignIn"
        className={mergeStyles('col-lg-12', contactUsClassNames.col, contactUsClassNames.bodyCopySmall)}
        style={{ whiteSpace: 'pre-line' }}
        dangerouslySetInnerHTML={sanitizeHTML(tryAgainLink, ['onclick'])} // eslint-disable-line
      />
    );
  }
  return Body;
};
